module.exports = __webpack_public_path__ + "img/ico-ig.1c6742d8.svg";